import Swal from 'sweetalert2';

import React, { useEffect, useState } from 'react';
import { Button, Header, Icon, Modal, Step, Loader, Dimmer } from 'semantic-ui-react';
import { CancellationFormik } from '../Formik/CancellationFormFormik';
import { CancelModalProps } from '../../../types';
import withReactContent from 'sweetalert2-react-content';
import { post } from '../../../../../services/request';
import {
  dangerNotification,
  successNotification
} from '../../../../../services/notification';
import { postFileAndGetPreSignAxios, deleteFilesLinkAxios } from '../../../../../services/file';
import { fileToBlob, sanitizeFilename, validateFileAccessibility } from '../../../../../utils/fileUtils';
import styled from 'styled-components';

const StepWrapper = styled(Step)`
  .title {
    color: ${props => props.theme.main.color} !important;
  }
`;

const CancelModal = ({
  openModal,
  closeModal,
  setOpen,
  hiredDataId,
  bondInsuranceId,
  callback
}: CancelModalProps) => {
  const [flagSubmitFrom, setFlagSubmitFrom] = useState(false);
  const [stepOfCancelModal, setStepOfCancelModal] = useState('cancellation');

  const [loading, setLoading] = useState(false);

  const MySwal = withReactContent(Swal);

  async function submitFiles(
    files: {
      file: File;
      name: string;
    }[]
  ) {
    const responses = [];
    for (const file of files) {
      let fileId: string | null = null;

      try {
        // Validar se o arquivo está acessível ANTES de obter o presigned URL
        await validateFileAccessibility(file.file);

        const response = await postFileAndGetPreSignAxios({
          filename: sanitizeFilename(file.file.name),
          contentType: file.file.type,
          referencedTableName: 'bond_insurance',
          referencedTableId: bondInsuranceId,
          name: file.name
        });

        fileId = response.id;

        const blob = await fileToBlob(file.file);

        const uploadResponse = await fetch(response.uploadURL, {
          method: 'PUT',
          body: blob
        });

        if (!uploadResponse.ok) {
          throw new Error(`Falha no upload: ${uploadResponse.status} ${uploadResponse.statusText}`);
        }

        responses.push({ id: response.id, contextType: file.name });
      } catch (uploadError) {
        // Se falhou após criar a entrada no banco, fazer rollback
        if (fileId) {
          try {
            console.log(`[Upload] Rollback: removendo entrada órfã ${fileId}`);
            await deleteFilesLinkAxios(fileId);
          } catch (deleteError) {
            console.error(`[Upload] Falha ao remover entrada órfã ${fileId}:`, deleteError);
          }
        }
        throw uploadError;
      }
    }
    return responses;
  }

  async function handleSubmit(payload: any) {
    console.log('PAYLOAD: ', payload);
    MySwal.fire({
      title: `Atenção`,
      text: 'Esta ação é irreversível e consequentemente não será possível realizar a abertura de sinistro para indenização. Deseja prosseguir? ',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo prosseguir',
      cancelButtonText: 'Não'
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const files = await submitFiles(payload.files);
          console.log({ files });
          const response = await post('/canceled-bond-insurances/proposal', payload);
          console.log(response);
          successNotification(
            'Sucesso',
            'Solicitação de Cancelamento recebida com sucesso.'
          );
        } catch (err) {
          const errorMessage = (err as Error)?.message || 'Erro ao efetuar solicitação.';
          dangerNotification('Erro', errorMessage, 4000);
          console.log(err);
        } finally {
          callback();
          setLoading(false);
          setFlagSubmitFrom(false);
          closeModal();
        }
      }
    });
  }

  return (
    <div style={{ outline: 'none' }}>
      <Modal
        closeIcon
        open={openModal}
        onClose={() => closeModal()}
        trigger={
          <Button style={{ width: '100%', borderRadius: 0, backgroundColor: '#fff' }}>
            <Icon name={'trash'} />
            Solicitar Cancelamento
          </Button>
        }
      >
        <Header icon="file alternate outline" content={`Cancelamento de Proposta`} />
        <Modal.Content>
          <Dimmer active={loading}>
            <Loader indeterminate> Salvando proposta... </Loader>
          </Dimmer>
          <Step.Group>
            <StepWrapper
              onClick={() => setStepOfCancelModal('cancellation')}
              active={stepOfCancelModal === 'cancellation'}
              title={`Cancelamento`}
              description=""
            />
          </Step.Group>
          {stepOfCancelModal === 'cancellation' && (
            <CancellationFormik
              flagSubmit={flagSubmitFrom}
              setFlagSubmit={setFlagSubmitFrom}
              callbackSubmit={handleSubmit}
              hiredDataId={hiredDataId}
              closeModal={closeModal}
            />
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={() => closeModal()}>
            <Icon name="remove" /> Sair
          </Button>
          <Button color="green" onClick={() => setFlagSubmitFrom(true)}>
            <Icon name="checkmark" />
            Confirmar
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};
export default CancelModal;
